import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

export const leaveTypeKeys = {
    all: ['leave-types'],
    lists: () => [...leaveTypeKeys.all, 'list'],
    list: (orgId) => [...leaveTypeKeys.lists(), orgId],
};

// Fetch leave types
export function useLeaveTypes(orgId) {
    return useQuery({
        queryKey: leaveTypeKeys.list(orgId),
        queryFn: () => apiHelper.getResource('/leave/types/', { orgId }),
        enabled: !!orgId,
    });
}

// Create leave type
export function useCreateLeaveType() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ data, orgId }) => {
            const options = orgId ? { orgId } : {};
            return apiHelper.postResource('/leave/types/', data, options);
        },
        onSuccess: (_, { orgId }) => {
            queryClient.invalidateQueries({ queryKey: leaveTypeKeys.list(orgId) });
        },
    });
}

// Update leave type (if needed in future, adding placeholder)
export function useUpdateLeaveType() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data, orgId }) => {
            const options = orgId ? { orgId } : {};
            return apiHelper.putResource(`/leave/types/${id}/`, data, options);
        },
        onSuccess: (_, { orgId }) => {
            queryClient.invalidateQueries({ queryKey: leaveTypeKeys.list(orgId) });
        },
    });
}

// Delete leave type
export function useDeleteLeaveType() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, orgId }) => {
            const options = orgId ? { orgId } : {};
            return apiHelper.deleteResource(`/leave/types/${id}/`, options);
        },
        onSuccess: (_, { orgId }) => {
            queryClient.invalidateQueries({ queryKey: leaveTypeKeys.list(orgId) });
        },
    });
}
